import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { DateTime } from "b2b/renderers";

import useMessages from "./i18n/useMessages";

export function ZadostEditaceWidgetTitleDescription({ zadost, loading }) {
  const { labelTitleDescription, title } = useMessages();
  return loading ? (
    <PlaceholderText>{title({ id: "" })}</PlaceholderText>
  ) : (
    <span>
      <span>{`${labelTitleDescription()}: `}</span>
      <DateTime val={zadost.datumVytvoreni} />
    </span>
  );
}

ZadostEditaceWidgetTitleDescription.propTypes = {
  loading: T.bool,
  zadost: T.object
};

export default React.memo(ZadostEditaceWidgetTitleDescription);
